import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "col-12 mb-3" };
const _hoisted_2 = { class: "col-12 bg-white border rounded-bottom pt-3 mb-4" };
const _hoisted_3 = { class: "row mt-3" };
const _hoisted_4 = { class: "col-12 mb-2 font2 strong text-left" };
const _hoisted_5 = {
    key: 0,
    class: "col-12 mb-3 font6 mt-n2 text-left"
};
const _hoisted_6 = { class: "strong" };
const _hoisted_7 = { class: "row mb-1" };
const _hoisted_8 = { class: "col-12 font7" };
const _hoisted_9 = {
    class: "float-left",
    style: { "max-width": "90%" }
};
const _hoisted_10 = {
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: "",
    class: "strong font7",
    "data-original-title": "myPOINTS werden Dir mit der Auszahlung gutgeschrieben und\n                                                   können gegen Gutscheine eingetauscht werden"
};
const _hoisted_11 = { class: "" };
const _hoisted_12 = { class: "row mb-3" };
const _hoisted_13 = { class: "col-12 font7" };
const _hoisted_14 = {
    class: "float-left strong",
    style: { "max-width": "90%" }
};
const _hoisted_15 = {
    key: 0,
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    class: "strong font7",
    "data-original-title": "Die angezeigte Summe gilt, sofern das Produkt im beschriebenen\n                                                   Zustand innerhalb von 3 Tagen im ausgewählten Store eingeht."
};
const _hoisted_16 = {
    key: 1,
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    class: "strong font7",
    "data-original-title": "Die angezeigte Summe gilt, sofern das Produkt im beschriebenen\n                                                   Zustand innerhalb von 7 Tagen bei mySWOOOP eingeht."
};
const _hoisted_17 = { class: "row mt-3" };
const _hoisted_18 = { class: "col-12" };
const _hoisted_19 = {
    key: 0,
    class: "icon-spin4 animate-spin"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const _component_coupon_usage_block = _resolveComponent("coupon-usage-block");
    const _component_formatted_price = _resolveComponent("formatted-price");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_coupon_usage_block, {
            couponType: _ctx.CouponType.RED,
            coupons: _ctx.coupons,
            currentCouponCode: _ctx.currentCouponCode,
            onLoadCoupons: _ctx.load_coupons,
            "remove-coupon-callback": _ctx.removeCoupon,
            "confirm-coupon-code-callback": _ctx.setCouponCodeToCart,
            class: "col-12 pt-1 pb-2 bg-white vouchers border-top border-left border-right rounded-top mb-0"
        }, null, 8, ["couponType", "coupons", "currentCouponCode", "onLoadCoupons", "remove-coupon-callback", "confirm-coupon-code-callback"]),
        _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row border-bottom" }, [
                _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("h2", { class: "h5 mb-3 mt-1 text-left" }, "Auszahlungssumme")
                ])
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_formatted_price, {
                        class: "strong",
                        price: (_b = (_a = _ctx.cart) === null || _a === void 0 ? void 0 : _a.total) !== null && _b !== void 0 ? _b : 0
                    }, null, 8, ["price"])
                ]),
                ((_c = _ctx.cart) === null || _c === void 0 ? void 0 : _c.coupon_value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _cache[1] || (_cache[1] = _createTextVNode(" Enthält ", -1)),
                        _createElementVNode("span", _hoisted_6, [
                            _createVNode(_component_formatted_price, {
                                class: "strong",
                                price: (_e = (_d = _ctx.cart) === null || _d === void 0 ? void 0 : _d.coupon_value) !== null && _e !== void 0 ? _e : 0
                            }, null, 8, ["price"])
                        ]),
                        ((_f = _ctx.cart) === null || _f === void 0 ? void 0 : _f.coupon_is_external)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" Deines " + _toDisplayString((_g = _ctx.cart) === null || _g === void 0 ? void 0 : _g.coupon_external_name_hint) + " Partnergutscheins ", 1)
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(' ') + "Deines Gutscheins")
                            ], 64))
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _cache[3] || (_cache[3] = _createTextVNode(" Mit diesem Verkaufsauftrag ", -1)),
                        _createElementVNode("span", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString((_h = _ctx.cart) === null || _h === void 0 ? void 0 : _h.bonus_points), 1),
                            _cache[2] || (_cache[2] = _createTextVNode(" myPoints ", -1))
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode(" sichern. ", -1))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        (((_k = (_j = _ctx.cart) === null || _j === void 0 ? void 0 : _j.payout_option) === null || _k === void 0 ? void 0 : _k.type) === 'LOCAL-STORE-PAYOUT')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Angebot gültig für 3 Tage "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, " Angebot gültig für 7 Tage "))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.confirm_sale && _ctx.confirm_sale(...args))),
                        type: "button",
                        class: "buttonBase buttonGreen w-100 font6-responsive mb-3 strong JS_shaky_bad [ track_red_checkout_complete ] [ JS_Sticky_Anchor_Confirm_Checkout_RED ]",
                        id: "confirm_checkout",
                        style: { "position": "relative", "left": "0px" }
                    }, [
                        (_ctx.pendingAjaxCalls)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                            : _createCommentVNode("", true),
                        _cache[5] || (_cache[5] = _createTextVNode(" Bestätigen und verkaufen ", -1))
                    ])
                ])
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row mt-3" }, [
                _createElementVNode("div", { class: "col-12 text-center" }, [
                    _createElementVNode("p", { class: "font7 greyish_text" }, [
                        _createTextVNode(" Mit dem Klick bestätige ich, dass ich die "),
                        _createElementVNode("a", {
                            href: "/agb",
                            target: "_blank",
                            title: "AGB",
                            class: "strong link-gray"
                        }, "AGB"),
                        _createTextVNode(" gelesen und akzeptiert habe. ")
                    ])
                ])
            ], -1))
        ])
    ]));
}
